"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InviteUserModal = InviteUserModal;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const react_intl_1 = require("react-intl");
const elements_1 = require("@src/components/elements");
const Api = __importStar(require("@src/api"));
async function failIfUserExists(email) {
    try {
        await Api.Account.getAccountExistsByEmail(email);
        throw new Error('exists');
    }
    catch (err) {
        if (err.message === 'exists') {
            throw err;
        }
    }
}
function InviteUserModal(props) {
    var _a;
    const [isBeingSent, setIsBeingSent] = react_1.default.useState(false);
    const intl = (0, react_intl_1.useIntl)();
    const [form] = antd_1.Form.useForm();
    const onConfirm = react_1.default.useCallback(async () => {
        try {
            setIsBeingSent(true);
            await form.validateFields();
            const emails = form.getFieldValue('email');
            await Api.Admin.createInvitation(emails);
            await props.onSend();
            form.resetFields();
            props.close();
        }
        catch (err) {
            console.error(err);
        }
        finally {
            setIsBeingSent(false);
        }
    }, [form]);
    const accountsEmails = (_a = props.accounts) === null || _a === void 0 ? void 0 : _a.map(({ email }) => email);
    return ((0, jsx_runtime_1.jsx)(elements_1.Modal, { okText: intl.formatMessage({ id: 'general.buttons.send' }), title: intl.formatMessage({ id: 'admin.users.invite_users' }), width: 500, visible: props.isOpen, onOk: () => onConfirm(), okButtonProps: { loading: isBeingSent }, onCancel: () => {
            form.resetFields();
            props.close();
        }, destroyOnClose: true, children: (0, jsx_runtime_1.jsx)(antd_1.Form, { form: form, name: "dynamic_form_nest_item", autoComplete: "off", initialValues: { email: [] }, children: (0, jsx_runtime_1.jsx)(antd_1.Form.Item, { className: "m-b-none", name: "email", fieldKey: "email", normalize: value => value.map(v => v.toLowerCase().trim()).filter(Boolean), rules: [
                    { required: true, message: intl.formatMessage({ id: 'admin.users.missing_email' }) },
                    {
                        type: 'array',
                        defaultField: {
                            type: 'email',
                            message: intl.formatMessage({ id: 'admin.users.not_valid_email' }),
                        },
                        message: intl.formatMessage({ id: 'admin.users.not_valid_email' }),
                    },
                    {
                        validator: (_, value) => value.some(email => accountsEmails.includes(email))
                            ? Promise.reject(new Error(intl.formatMessage({
                                id: 'admin.users.invitation_user_already_exists_in_company',
                            })))
                            : Promise.resolve(),
                    },
                    {
                        validator: async (_, value) => new Promise((resolve, reject) => {
                            try {
                                Promise.all(value.map(email => failIfUserExists(email)))
                                    .then(() => {
                                    resolve(null);
                                })
                                    .catch(() => reject(new Error(intl.formatMessage({
                                    id: 'admin.users.invitation_user_already_exists',
                                }))));
                            }
                            catch (err) {
                                resolve(null);
                            }
                        }),
                    },
                ], children: (0, jsx_runtime_1.jsx)(elements_1.Select, { placeholder: "john.doe@email.com", mode: "tags", open: false }) }) }) }));
}
